/* eslint-disable react/prop-types */
import { HeaderName as CarbonHeaderName } from '@carbon/react';

export const HeaderName = ({ children, ...props }) => (
  <CarbonHeaderName {...props}>{children}</CarbonHeaderName>
);
